// extracted by mini-css-extract-plugin
export default {"footer":"DropdownFooter_footer__10SNT"};